import Vue from 'vue'
import {
    getThirdPartLoginHeader
} from './business'
import {
	infoTextArr,
	statusTypeMap,
	protocolType,
	statusBtnColor
} from '@/utils/constants'
import { getUserInfo } from '@/api/user'
import {loginConfig, loginSystemConfig} from '@/api/login'
import { setupOnlineServer } from '@/utils/onlineServer'
import i18n from '@/lang/index'
import { getmultilingualVersion } from '@/api/trade'

export async function fetchUserConfig(axios, $store) {
	const { data } = await axios.get('/user/config', {
		headers: getThirdPartLoginHeader()
	})
	if (data) {
		// 如果配置不展示积分商城 删除积分商城相关页面的权限
		if ($store.state.webConfig.pointsStatus === '0') {
			const list = ['pointsMall','myPoints','myExchange','PointsMallDeatil', 'SettingsIntro']
			data.userMenu = data.userMenu.filter(it => {
				if (!list.includes(it)) {
					return it
				}
			})
		}
		$store.commit('setPermissions', data)
		$store.commit('setcountUnRead', data.countUnRead)
		$store.commit('settagsSetting', data.tagsSetting)
	}
	if (data && data.userMenu && $store.getters.availablePages.length === 0) {
		let ev = new Event('ShowNoPermission')
		window.dispatchEvent(ev)
		return
	}
	return data
}

export async function getUserColumnInfo($axios, $store) {
	let userColumnInfo = []
	await $axios({
		url: '/' + 'user/personInfo',
		method: 'get'
	}).then(({ code, data }) => {
		if (code == 0) {
			data.person.type = 'person'
			data.finance.type = 'finance'
			data.identity.type = 'identity'
			data.protocol.type = 'protocol'
			let arr = [data.person, data.finance, data.identity, data.protocol]
			arr.forEach((item, index) => {
				userColumnInfo.push({
						infoText: infoTextArr[index],
						statusText:
							index !== 3
								? statusTypeMap[item.status]
								: protocolType[item.status],
						statusType: statusBtnColor[item.status],
						setting: item.setting,
						status: item.status,
						type: item.type
					})
			})
			// if protocol does not exist, its status is -1, it can not get a statusText, filter it out
			$store.commit('setUserColumnInfo', userColumnInfo.filter(item => item.statusText))
		}
	})
}

export async function isFirstNewLogin($axios, $store) {
	$axios({
		url: '/' + 'user/firstNewLogin',
		method: 'get'
	}).then(({ code, data }) => {
		if (code == 0) {
			$store.commit('setFirstNewLogin', data)
		}
	})
}

export async function get_allowed($axios, $store) {
	await $axios({
		url: '/' + 'server/allowed',
		method: 'get'
	})
		.then(({ code, data }) => {
			let serverAllowed = {
				bindAllowed: '0',
				demoAccountAllowed: '0',
				realAccountAllowed: '0'
			}
			if (code === 0) {
				if (JSON.stringify(data) !== '{}' && data !== null) {
					serverAllowed = data
				}
			}
			$store.commit('setServerAllowed', serverAllowed)
		})
		.catch(() => {
			this.serverAllowed = {
				bindAllowed: '0',
				demoAccountAllowed: '0',
				realAccountAllowed: '0'
			}
		})
}

export async function uploadPhoto(fileData, $ajax, $axios, $store) {
	let files = new window.File([fileData.file], fileData.file.name, {
		type: fileData.file.type
	})
	let formData = new FormData()
	formData.append('file', files)
	formData.append('category', 'crm/head')
	await $ajax.post('/picupload', formData).then(data => {
		let imgUrl = data.url
		let param = {
			avatar: data.url //头像链接
		}
		$axios.post('/' + 'user/editbase', param).then(({ code, msg }) => {
			if (code !== 0) {
				return
			} else {
				let status = 'success'
				new Vue().$message({
					message: msg,
					type: status,
					duration: 1000
				})
				$store.commit('setHeadImg', imgUrl)
			}
		})
	})
}

export async function get_userInfo($store) {
	const { code, data } = await getUserInfo()
	if (code == 0) {
		let headImg = data.headImg
		let userId = data.id
		let lastName = data.lastName
		let name = data.name
		let loginTime = data.tLastLogin
		let isSetPassword = data.isSetPassword
		let timeDeviation = data.currentDate - new Date().getTime()
		$store.commit('setAccountType', data.accountType)
		$store.commit('set_userInfo', {
			...data,
			headImg,
			userId,
			lastName,
			name,
			loginTime,
			timeDeviation,
			isSetPassword,
			mzone: data.mzone,
			email: data.email,
			mobile: data.mobile,
			boundGoogle: data.boundGoogle,
			hasDealAccount: data.hasDealAccount,
			antiPhishingCode: data.antiPhishingCode
		})
		localStorage.setItem('publicKey', data.publicKey)
	}
}

/**
 * 登录前调用
 * @param {*} $store
 * @param {*} isInitOnLineServer
 */
export async function getLoginConfig($store, isInitOnLineServer = false) {
	let { data, code } = await loginConfig()
	if (code === 0) {
	// 把背景图片和logo存在
	let logo = data.logo
	let backImg = data.back
	let darkLogo = data.darkLogo
	let loginLogo2 = data.loginLogo2
	let darkLogo2 = data.darkLogo2
	let isEnglish = data.nameLimitSwitch == 'true' ? true : false
	document.title = data.name
	$store.commit('set_isEnglish', isEnglish)
	$store.commit('set_logoBack', { logo, backImg, darkLogo,loginLogo2,darkLogo2 })
	$store.commit('setWebConfig', {
		...$store.state.webConfig,
		...data
	})
	localStorage.setItem('secretKey', data.secretKey)

	let dom = document.createElement('link')
	dom.rel = 'shortcut icon'
	dom.href = `${data.icon}`
	document.getElementsByTagName('head')[0].appendChild(dom)
	if (isInitOnLineServer) {
		setupOnlineServer({
			onlineServiceStatus: $store.state.webConfig.onlineServiceStatus,
			onlineServiceCode: $store.state.webConfig.onlineServiceCode,
			onlineServicePosition: $store.state.webConfig.onlineServicePosition
		})
	}
}
}

/**
 * 登录后调用
 * @param {*} $store
 */
export async function getSystemConfig($store) {
	let {data, code} = await loginSystemConfig()
	if (code === 0) {
	if (JSON.stringify(data) !== '{}') {
		data.fundPasswordDeposit = data.fundPasswordDeposit == 'true'
		data.fundPasswordWithdraw = data.fundPasswordWithdraw == 'true'
		data.fundPasswordTrans = data.fundPasswordTrans == 'true'
		let dom = document.createElement('link')
		dom.rel = 'shortcut icon'
		dom.href = `${data.icon}`
		document.getElementsByTagName('head')[0].appendChild(dom)
		document.title = data.name
		localStorage.setItem(
			'skipAddress',
			JSON.stringify(data.skipAddress)
		)
		// 缓存请求超时时间：当页面无任何点击操作且超时需要重新登录
		localStorage.setItem('loginLimitTime', data.clientLoginTimeout)
		$store.commit('setWebConfig', {
			...$store.state.webConfig,
			...data
		})
	}
	}
}

export async function getLanguageFileUpdate() {
	// 请求参数枚举
	const language = [
		{
			"id": 274,
			"sort": 1,
			"name": "简体中文",
			"value": "zh",
			"code": "zh-CN"
		},
		{
			"id": 276,
			"sort": 2,
			"name": "English",
			"value": "en",
			"code": "en-US"
		},
		{
			"id": 287,
			"sort": 3,
			"name": "한국어",
			"value": "ko",
			"code": "ko-KR"
		},
		{
			"id": 277,
			"sort": 4,
			"name": "日本語",
			"value": "ja",
			"code": "ja-JP"
		},
		{
			"id": 275,
			"sort": 5,
			"name": "繁體中文",
			"value": "tc",
			"code": "zh-TW"
		},
		{
			"id": 286,
			"sort": 6,
			"name": "ภาษาไทย",
			"value": "th",
			"code": "th-TH"
		},
		{
			"id": 278,
			"sort": 7,
			"name": "Tiếng Việt",
			"value": "vi",
			"code": "vi-VN"
		},
		{
			"id": 296,
			"sort": 8,
			"name": "Bahasa indonesia",
			"value": "id",
			"code": "id-ID"
		},
		{
			"id": 336,
			"sort": 9,
			"name": "العربية",
			"value": "ar",
			"code": "ar-AE"
		},
		{
			"id": 339,
			"sort": 10,
			"name": "Español",
			"value": "es",
			"code": "es-ES"
		},
		{
			"id": 472,
			"sort": 11,
			"name": "ພາສາລາວ",
			"value": "lo",
			"code": "lo-LA"
		},
		{
			"id": 534,
			"sort": 12,
			"name": "Français",
			"value": "fr",
			"code": "fr-FR"
		},{
			"id": 536,
			"sort": 13,
			"name": "Deutsch",
			"value": "de",
			"code": "de-DE"
		},
	]
	const param = language.filter(it => it.value == i18n.locale)
	if (param && param[0].code) {
		const data = await getmultilingualVersion(param[0].code)
		if (data.code === 0 && data?.data) {
			i18n.setLocaleMessage(i18n.locale, {
				...data?.data
			})
		}
	}
}
